<template>
    <div>
        <modal-dialog
            id="prospective-filters"
            :show.sync="shown"
            :class="{'lam-ghosted': !!picking_template}"
            class="uk-modal-dialog-large lam-export-builder"
        >
            <template v-slot:title>
                Export Builder
            </template>

            <div class="uk-grid uk-grid-small uk-flex" data-uk-grid-margin>
                <div class="uk-width-4-10">
                    <form class="uk-form uk-form-horizontal uk-grid uk-grid-small" data-uk-grid-margin @submit.prevent>
                        <div :class="{'uk-width-1-1': !templates.length, 'uk-width-8-10': !!templates.length}">
                            <div class="uk-form-icon uk-width-1-1">
                                <open-icon glyph="search" />
                                <input type="search" v-model="search" class="uk-width-1-1" />
                            </div>
                        </div>
                        <div v-if="!!templates.length"  class="uk-width-2-10 uk-text-right">
                            <base-button @click.native="picking_template=!picking_template">
                                <open-icon glyph="list-ul" />
                            </base-button>
                        </div>
                    </form>

                    <div class="lam-export-builder-field-list uk-margin-top">
                        <draggable v-model="available" tag="ul" :sort="false" group="fields" @end="maybe_reset_search" class="uk-list uk-list-line">
                            <li v-for="field in available" :key="field.id">
                                <span>{{ field.header }}</span>
                            </li>
                        </draggable>
                    </div>
                </div>

                <div class="uk-width-1-10 uk-text-center">
                    <h2>&nbsp;</h2>

                    <div class="lam-spacer uk-vertical-align">
                        <div class="uk-vertical-align-middle">
                            <open-icon glyph="arrows-h" />
                        </div>
                    </div>
                </div>

                <div class="uk-width-5-10">
                    <form class="uk-form uk-form-horizontal uk-grid uk-grid-small" data-uk-grid-margin @submit.prevent>
                        <div class=" uk-form-controls-text uk-width-1-2">
                            <h3>Export Columns {{current_template.name}}</h3>
                        </div>
                        <div class=" uk-form-controls-text uk-width-1-2 uk-text-right">
                            <templates-controls :template="current_template" :entity="entity" :savable="template_savable" :dirty="template_dirty" :clone="template_to_clone" @save="template_editor_save" @stop-editing="template_editor_close"></templates-controls>
                        </div>
                    </form>

                    <div class="lam-export-builder-field-list uk-margin-top">
                        <draggable v-model="picked" tag="ul" group="fields" @end="resample" class="uk-list uk-list-line">
                            <li v-for="field in picked" :key="field.id" class="clearfix">
                                <span>{{ field.header }}</span>
                                <base-button flavor="link" class="uk-float-right" @click.stop.prevent="make_available(field)">
                                    <open-icon glyph="close" />
                                </base-button>
                            </li>
                        </draggable>
                    </div>
                </div>
            </div>

            <hr />

            <div class="uk-grid uk-grid-small uk-margin-top" data-uk-grid-margin>
                <div class="uk-width-1-1">
                    <h3 v-if="!!picked.length" class="uk-text-center">Sample output</h3>

                    <div v-if="!!picked.length" class="uk-overflow-container">
                        <export-samples
                            :sample-columns="columns"
                            :sample-rows="sample"
                        />
                    </div>
                    <div v-else class="uk-text-center uk-text-muted">
                        Drag fields from the left list onto the right list, to build the columns of your export file.
                    </div>
                </div>
            </div>

            <div class="uk-modal-footer uk-text-center">
                <div class="uk-grid">
                    <div class="uk-width-1-2">
                        <base-button size="large" :block="true" :disabled="loading" @click.native.prevent="close">Cancel</base-button>
                    </div>
                    <div class="uk-width-1-2">
                        <base-button :waiting="loading" color="primary" size="large" :block="true" :disabled="!this.picked.length" @click.native.prevent="download">Export Data</base-button>
                    </div>
                </div>
            </div>
        </modal-dialog>

        <template-picker
            :template="current_template"
            :entity="entity"
            :active="picking_template"
            title="Export Columns Templates"
            @close="picking_template=false"
            @clone="template_clone"
            @load="template_load"
        />
    </div>
</template>

<script type="text/javascript">
import { orderBy } from "lodash"

import templatable from "../mixins/Templatable"

import ExportSamples from "./ExportSamples"
import ModalDialog from "../dialogs/ModalDialog/ModalDialog"
import BaseButton from "../ui/BaseButton"
import TemplatesControls from "../ui/TemplatesControls"
import TemplatePicker from "../ui/TemplatePicker"
import OpenIcon from "../ui/OpenIcon"

import draggable from "vuedraggable"

export default {
    name: "ExportBuilder",
    components: {
        ExportSamples,
        ModalDialog,
        BaseButton,
        TemplatesControls,
        TemplatePicker,
        OpenIcon,
        draggable
    },
    mixins: [templatable],
    methods: {
        close () {
            this.$emit("update:show", false)
            this.loading = false
            this.picking_template = false
        },
        download () {
            if(this.picked.length) {
                this.loading = true
                const server_query = { ...this.query }
                server_query.fields = this.picked.map((field) => field.id)
                this.$store.dispatch("EXPORT_RECORDS", { entity: this.entity, query: server_query }).then((response) => {
                    if(response.error) this.$error(response.error)
                    else if(response.success) {
                        this.$success(response.success)
                        this.close()
                    }
                }).then(() => {
                    this.loading = false
                })
            }
        },
        maybe_reset_search () {
            if(!this.available.length && !!this.search) this.search = ""
            this.resample()
        },
        make_available (field) {
            this.picked = this.picked.filter(picked => picked.id !== field.id)
            this.resample()
        },
        resample () {
            const server_query = { ...this.query }
            server_query.page = 1
            server_query.per_page = 5
            server_query.fields = this.picked.map((field) => field.id)
            server_query.exporting = 1
            this.$store.dispatch("SAMPLE_RECORDS", { entity: this.entity, query: server_query }).then((records) => {
                this.sample = records
            })
        },
        template_load_ui () {
            if(this.current_template && this.current_template.content) {
                this.picked = []
                if(window.nibnut.vue.application_export_fields[this.entity]) {
                    Object.values(window.nibnut.vue.application_export_fields[this.entity]).forEach(field => {
                        if(this.fields.indexOf(field.id) < 0) return
                        if(this.current_template.content.indexOf(field.id) < 0) return
                        this.picked.push(field)
                    })
                }
            }
        },
        new_template_content () {
            return this.picked.map(field => field.id).slice()
        }
    },
    computed: {
        shown: {
            get: function () {
                return this.show
            },
            set: function (show) {
                if(!show) this.close()
            }
        },
        available: {
            get () {
                let available = []

                if(window.nibnut.vue.application_export_fields[this.entity]) {
                    Object.values(window.nibnut.vue.application_export_fields[this.entity]).forEach(field => {
                        if(this.fields.indexOf(field.id) < 0) return
                        if(this.picked.find(picked => field.id === picked.id)) return
                        available.push(field)
                    })
                }

                if(this.search) {
                    const search_string = this.search.toLowerCase()
                    available = available.filter(field => {
                        return field.header.toLowerCase().indexOf(search_string) > -1
                    })
                }

                return orderBy(available, ["order", "header"], ["asc"])
            },
            set (value) {
                // console.log(value)
            }
        },
        columns () {
            const columns = {}
            this.picked.forEach(picked => {
                columns[picked.id] = { label: picked.header, sort: false, type: "plain" }
            })
            return columns
        }
    },
    props: {
        entity: {
            type: String,
            required: true
        },
        fields: {
            type: Array,
            required: true
        },
        query: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            loading: false,
            search: "",
            picked: [],
            sample: []
        }
    }
}
</script>
